/**
 * Open-publications session (document tabs) persisted in IndexedDB so a reload — or the browser closing — never loses
 * the publications that were open. Snapshots are stored without the undo history. Everything is best-effort: any
 * storage failure is swallowed (private mode, quota, unsupported browser).
 */
const DB = 'wannapublish';
const STORE = 'session';
const KEY = 'open-publications';
export const SESSION_VERSION = 1;

const openDb = () => new Promise((resolve, reject) => {
  if (typeof indexedDB === 'undefined') { reject(new Error('IndexedDB unavailable')); return; }
  const req = indexedDB.open(DB, 1);
  req.onupgradeneeded = () => { if (!req.result.objectStoreNames.contains(STORE)) req.result.createObjectStore(STORE); };
  req.onsuccess = () => resolve(req.result);
  req.onerror = () => reject(req.error);
});

const tx = async (mode, fn) => {
  const db = await openDb();
  try {
    return await new Promise((resolve, reject) => {
      const t = db.transaction(STORE, mode);
      const store = t.objectStore(STORE);
      const req = fn(store);
      t.oncomplete = () => resolve(req ? req.result : undefined);
      t.onerror = () => reject(t.error);
      t.onabort = () => reject(t.error);
    });
  } finally { db.close(); }
};

/** Strip what must not be persisted (undo history, transient selection). */
export const docForSession = (doc) => {
  if (!doc) return null;
  const { history, historyIndex, historyDirty, selectedObjectIds, ...rest } = doc;
  return rest;
};

export const saveSession = async (session) => {
  try { await tx('readwrite', (store) => store.put({ version: SESSION_VERSION, savedAt: Date.now(), ...session }, KEY)); return true; } catch { return false; }
};

export const loadSession = async () => {
  try {
    const s = await tx('readonly', (store) => store.get(KEY));
    return s && s.version === SESSION_VERSION && Array.isArray(s.tabs) ? s : null;
  } catch { return null; }
};

export const clearSession = async () => { try { await tx('readwrite', (store) => store.delete(KEY)); } catch { /* ignore */ } };
